export default __webpack_public_path__ + "static/media/c_mobile_dr_02.fd090af6.png";